// extracted by mini-css-extract-plugin
export default {"cellWrapper":"TableImage_cellWrapper__8PF5V","photoCell":"TableImage_photoCell__vnXQV"};